import { render } from "./NavigationAdmin.vue?vue&type=template&id=9a436f18&scoped=true"
import script from "./NavigationAdmin.vue?vue&type=script&lang=js"
export * from "./NavigationAdmin.vue?vue&type=script&lang=js"

import "./NavigationAdmin.vue?vue&type=style&index=0&id=9a436f18&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a436f18"]])

export default __exports__